function getPriceStepState(state) {
  return {
    priceInfo: state.price.priceInfo,
    priceError: state.price.priceError,
    priceCompleted: state.price.priceCompleted,
    priceLoading: state.price.priceLoading,
    priceFeatures: state.price.priceFeatures,
    realEstateType: state.price.realEstateType
  };
}

export { getPriceStepState };
